const adminSettingCustomTimerCTRLStyle = {
    container: {
        justifyContent: 'center',
        marginTop: '20px',
    },
    customSite: {
        marginBottom: '20px',
    },
    customSiteExhibitor: {
        marginTop: '40px',
        marginBottom: '20px',
    },
    customFooter: {
        marginBottom: '20px',
        marginTop: '20px',
    },
    customButton: {
        width: '150px',
    },
    customButtonReset: {
        width: '150px',
        margin: '0 20px',
    },
    customFooterButton: {
        textAlign: 'end',
    },
   
};

export default adminSettingCustomTimerCTRLStyle;
